import { Banner } from './components/banner';
import { Categories } from './components/categories';
import { ScrollableContainer } from './components/scrollableContainer';
import { StoreDetailsCard } from './components/storeDetailsCard';
import { bestDeals, discountStores } from '../lib/constants';
import styles from './styles.module.css';
import { useGetStoresListQuery } from '../redux/services/storesApi';
import { useNavigate } from 'react-router';

export const Marketplace = () => {

  const { data: stores, isLoading, isError } = useGetStoresListQuery();

  //   if (isLoading) return <p>Loading stores...</p>;
  // if (isError) return <p>Failed to fetch stores.</p>;

  // If the user is logged in 
  //Check if user has a store
  // if store exists, display dashboard
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <Categories />
      <Banner />
      <ScrollableContainer containername="Today’s Best Deals">
        {bestDeals.map((item) => (
          <StoreDetailsCard
            storePreview={item.storePreview}
            storeName={item.storeName}
            storeRating={item.storeRating}
            storeCreationDate={item.storeCreationDate}
            storeItemCount={item.storeItemCount}
            storeLocation={item.storeLocation}
            storeId=''
            storePrice={item.storePrice}
            onClick={() => 
            {
              navigate("/openX")
            }}
          />
        ))}
      </ScrollableContainer>

      <ScrollableContainer containername="Discount Stores">
        {discountStores.map((item) => (
          <StoreDetailsCard
            storePreview={item.storePreview}
            storeName={item.storeName}
            storeRating={item.storeRating}
            storeCreationDate={item.storeCreationDate}
            storeItemCount={item.storeItemCount}
            storeLocation={item.storeLocation}
            storeId=''
            storePrice={item.storePrice}
            onClick={() => 
            {
              navigate("/openX")
            }}
          />
        ))}
      </ScrollableContainer>

      <ScrollableContainer containername="Newly Featured">
        {discountStores.map((item) => (
          <StoreDetailsCard
            storePreview={item.storePreview}
            storeName={item.storeName}
            storeRating={item.storeRating}
            storeCreationDate={item.storeCreationDate}
            storeItemCount={item.storeItemCount}
            storeLocation={item.storeLocation}
            storeId=''
            storePrice={item.storePrice}
            onClick={() => 
            {
              navigate("/openX")
              //Working with kene to upload biafra ios test builds to testflight
              //Linking the dummy openx store to the marketplace ui
              //Fixed the not found issue
              //Fixing resposiveness
            }}
          />
        ))}
      </ScrollableContainer>
    </div>
  );
};
